import { isNil, omit } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { toIsoDateFormat } from 'utils';
import { fromIsoDateToDate } from 'utils/apiDateTime';

import { CONTACT_DATA_PRINT_COLUMN_ID } from './constants';
import { FIELDS } from './form';

// part of campaign detail is editable and is saved in form data
export const bodyFactory = (formData, campaignDetail, newOrEditCampaignPermission) => {
	if (newOrEditCampaignPermission) {
		const { channel, campaignType, ...formDataRest } = formData;

		return {
			...campaignDetail,
			...formDataRest,
			channelId: !isNilOrEmpty(channel) ? Number(channel) : null,
			type: campaignType,
			startDate: formData?.startDate && toIsoDateFormat(formData?.startDate),
			endDate: formData?.endDate && toIsoDateFormat(formData?.endDate),
			openLetterDate: formData.openLetterDate && toIsoDateFormat(formData.openLetterDate),
			orderStartDate: formData.orderStartDate && toIsoDateFormat(formData.orderStartDate),
			orderEndDate: formData.orderEndDate && toIsoDateFormat(formData.orderEndDate),
		};
	} else {
		const formDataWithoutPossiblyEditableFields = omit(
			[
				FIELDS.campaignName,
				FIELDS.startDate,
				FIELDS.endDate,
				FIELDS.communicationName,
				FIELDS.channel,
				FIELDS.campaignType,
			],
			formData,
		);

		return {
			...campaignDetail,
			...formDataWithoutPossiblyEditableFields,
			openLetterDate: formData.openLetterDate && toIsoDateFormat(formData.openLetterDate),
			orderStartDate: formData.orderStartDate && toIsoDateFormat(formData.orderStartDate),
			orderEndDate: formData.orderEndDate && toIsoDateFormat(formData.orderEndDate),
		};
	}
};

export const reorderColumnsWithPrintAtTheEnd = (columns) => {
	const printIndex = columns.indexOf(CONTACT_DATA_PRINT_COLUMN_ID);
	if (printIndex > -1) {
		// append print at the end
		return [...columns.filter((column) => column !== CONTACT_DATA_PRINT_COLUMN_ID), CONTACT_DATA_PRINT_COLUMN_ID];
	} else {
		return columns;
	}
};

export const formDataFactory = (campaignDetail, newOrEditCampaignPermission) => {
	return {
		...(newOrEditCampaignPermission && {
			campaignName: campaignDetail.campaignName,
			startDate: campaignDetail.startDate ? fromIsoDateToDate(campaignDetail.startDate) : null,
			endDate: campaignDetail.endDate ? fromIsoDateToDate(campaignDetail.endDate) : null,
			communicationName: campaignDetail.communicationName,
			campaignType: campaignDetail.type,
			channel: campaignDetail.channelId ? `${campaignDetail.channelId}` : null,
		}),

		description: campaignDetail.description,
		letterPrintedDate: Boolean(campaignDetail.letterPrintedDate),
		addMatOrder: Boolean(campaignDetail.addMatOrder),
		nominationDate: Boolean(campaignDetail.nominationDate),
		expectedReplacement: !isNil(campaignDetail.expectedReplacement)
			? String(campaignDetail.expectedReplacement)
			: undefined,
		productionPlan: !isNil(campaignDetail.productionPlan) ? String(campaignDetail.productionPlan) : undefined,
		expectedValue: !isNil(campaignDetail.expectedValue) ? String(campaignDetail.expectedValue) : undefined,
		openLetterDate: campaignDetail.letterPrintedDate ? fromIsoDateToDate(campaignDetail.openLetterDate) : null,
		orderStartDate: campaignDetail.addMatOrder ? fromIsoDateToDate(campaignDetail.orderStartDate) : null,
		orderEndDate: campaignDetail.addMatOrder ? fromIsoDateToDate(campaignDetail.orderEndDate) : null,
	};
};
